import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
/* import { GET_DASHBOARDLIST  } from '../../actions'; */

class List extends Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      dashboardlist:'',
      totalRecordUsers:0,
      totalRecordBrokers:0,
      totalRecordAds:0,
      totalRecordMenus:0,
      totalRecordFonts:0,
      totalRecordTemplates:0,
      totalRecordQuotations:0,
    };
    
    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var loggedas = localStorage.getItem("loggedas");
    var postobject = {
    activePage: 1,
    search_all: '',
    admin_id: admin_id,
    loggedas: loggedas
    };

    axios.post(apiUrl+"dashboard/list",qs.stringify(postobject)).then(res => {
     
      if(res.data.status === 'success'){
        this.setState({ 
          totalRecordUsers : res.data.records_count_users,
          totalRecordBrokers : res.data.records_count_brokers,
          totalRecordAds : res.data.records_count_ads,
          totalRecordMenus : res.data.records_count_menu,
          totalRecordFonts : res.data.records_count_font,
          totalRecordTemplates : res.data.records_count_template,
          totalRecordQuotations : res.data.records_count_quotation,
          });
      }
    }); 

    }

   
    componentDidMount() {
   }




  render() {
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="dashboard" currentTab="car" />
      
      <div className="content"> 
        <div className="content-wrapper">
              <div class="content-wrapper-before"></div>
              <div className="car-listing-wrap dashboard-wrap leaa-admin-head card">

                  <div className="title">
                    <h3>Dashboard</h3>
                  </div>

                  <div className="form-row first">
                    {localStorage.getItem('admin_id') === '1' ?  <div className="form-left">
                      <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                        <div className="card-header">
                            <h4 className="card-title card-badge card-title-black ">{this.state.totalRecordUsers}</h4>
                        </div>
                        <a href="/user" className="">
                          <div className="card-content collapse show">
                              <div className="card-body p-1">
                                  <h4 className="fs-4 text-bold-400 px-4">Users<i className="fa fa-building float-right"></i></h4>
                              </div>
                              <div className="card-footer p-1">
                              </div>
                          </div>
                        </a>
                      </div>
                    </div>: ''}                   
                    <div className="form-right">
                      <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                        <div className="card-header">
                          <h4 className="card-title card-badge card-title-black">{this.state.totalRecordBrokers}</h4>
                        </div>
                        <a href="/pluginowner" className="">
                          <div className="card-content collapse show">
                              <div className="card-body p-1">
                                  <h4 className="fs-4 text-bold-400 px-4">Brokers <i className="fa fa-building float-right"></i></h4>
                              </div>
                              <div className="card-footer p-1">
                              </div>
                          </div>
                        </a>
                      </div>
                    </div>  
                    
                  </div> 

                    <div className="form-row ">
                      <div className="form-left">
            					
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-black">{this.state.totalRecordAds}</h4>
                            </div>
                              <a href="/advertisement" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="fs-4 text-bold-400 px-4">Advertisements<i className=" float-right">
                                          <svg width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="15 18.4 69.95 62.99">  <path d="m16.699 55.898c0.69922 3.6992 3.8984 6.3008 7.6016 6.3008 0.5 0 0.89844 0 1.3008-0.10156l15.898-2.8984c0.39844-0.10156 26.102 7.6992 26.102 7.6992 0.19922 0.10156 0.39844 0.10156 0.59766 0.10156 0.39844 0 0.69922-0.10156 1-0.39844 0.39844-0.39844 0.60156-0.89844 0.5-1.5l-8.1016-45.398c-0.10156-0.5-0.5-1-1-1.1992-0.5-0.19922-1.1016-0.10156-1.5 0.30078 0 0-21.398 16.199-21.801 16.199l-15.898 2.9961c-2 0.39844-3.8008 1.5-5 3.1992-1.1992 1.6992-1.6016 3.6992-1.3008 5.8008zm2.1016-13c0.69922-1 1.8008-1.6992 3-2 0.5-0.10156 1.1016 0.30078 1.1992 0.80078 0.10156 0.5-0.30078 1.1016-0.80078 1.1992-0.69922 0.10156-1.3008 0.5-1.8008 1.1016-0.39844 0.60156-0.60156 1.3008-0.39844 2l0.5 2.6992c0.10156 0.60156-0.30078 1.1016-0.80078 1.1992h-0.19922c-0.5 0-0.89844-0.30078-1-0.80078l-0.5-2.6992c-0.10156-1.2969 0.10156-2.5 0.80078-3.5z"></path>  <path d="m35.898 63.398-5.3008 0.89844-3.1016 0.60156 4.8008 11.699c1.1992 3 3.6992 4.8008 6.3984 4.8008 0.30078 0 0.60156 0 1-0.10156l4.6016-0.80078c0.5-0.10156 0.89844-0.39844 1.1016-0.80078 0.19922-0.39844 0.30078-0.89844 0.10156-1.3008l-6.5-15.496z"></path>  <path d="m71.602 43h0.30078l10-1.8008c0.80078-0.19922 1.3984-1 1.1992-1.8008-0.19922-0.80078-1-1.3984-1.8008-1.1992l-10 1.8008c-0.80078 0.19922-1.3984 1-1.1992 1.8008 0.19922 0.59766 0.79688 1.1992 1.5 1.1992z"></path>  <path d="m73.398 52.398c-0.80078-0.19922-1.6992 0.19922-1.8984 1.1016-0.19922 0.80078 0.19922 1.6992 1.1016 1.8984l10.398 2.9023c0.10156 0 0.30078 0.10156 0.39844 0.10156 0.69922 0 1.3008-0.39844 1.5-1.1016 0.19922-0.80078-0.19922-1.6992-1.1016-1.8984z"></path>  <path d="m78.602 21.898c-0.5-0.69922-1.5-0.80078-2.1992-0.30078l-8.8008 6.4023c-0.69922 0.5-0.80078 1.5-0.30078 2.1992 0.30078 0.39844 0.80078 0.60156 1.3008 0.60156 0.30078 0 0.60156-0.10156 0.89844-0.30078l8.8008-6.3984c0.69922-0.5 0.80078-1.5 0.30078-2.2031z"></path> </svg>
                                          </i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
            					</div>
                      <div className="form-right">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                          <div className="card-header">
                            <h4 className="card-title card-badge card-title-black">{this.state.totalRecordFonts}</h4>
                          </div>
                          <a href="/fonts" className="">
                            <div className="card-content collapse show">
                                <div className="card-body p-1">
                                    <h4 className="fs-4 text-bold-400 px-4">Fonts <i className="fa fa-font float-right"></i></h4>
                                </div>
                                <div className="card-footer p-1">
                                </div>
                            </div>
                          </a>
                        </div>
            					</div>                                					
            				</div>
                    <div className="form-row ">
            					<div className="form-left">
                        <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                            <div className="card-header">
                                <h4 className="card-title card-badge card-title-black">{this.state.totalRecordTemplates}</h4>
                            </div>
                              <a href="/templates" className="">
                                <div className="card-content collapse show">
                                    <div className="card-body p-1">
                                        <h4 className="fs-4 text-bold-400 px-4">Templates<i className="float-right">
                                          <svg width="32" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <path d="m12.5 45.312h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v37.5c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-37.5c0-2.5898 2.0977-4.6875 4.6875-4.6875z"></path>  <path d="m12.5 7.8125h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v18.75c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-18.75c0-2.5898 2.0977-4.6875 4.6875-4.6875z"></path>  <path d="m59.375 64.062h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v18.75c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-18.75c0-2.5898 2.0977-4.6875 4.6875-4.6875z"></path>  <path d="m59.375 7.8125h28.125c2.5898 0 4.6875 2.5898 4.6875 4.6875v37.5c0 2.5898-2.0977 4.6875-4.6875 4.6875h-28.125c-2.5898 0-4.6875-2.5898-4.6875-4.6875v-37.5c0-2.5898 2.0977-4.6875 4.6875-4.6875z"></path> </svg>
                                          </i></h4>
                                    </div>
                                    <div className="card-footer p-1">
                                    </div>
                                </div>
                          </a>
                        </div>   
            					</div> 
                       <div className="form-right">
                      <div className="card pull-up border-top-info-black border-top-3 rounded-0">
                        <div className="card-header">
                          <h4 className="card-title card-badge card-title-black">{this.state.totalRecordQuotations}</h4>
                        </div>
                        <a href="/pluginowner" className="">
                          <div className="card-content collapse show">
                              <div className="card-body p-1">
                                  <h4 className="fs-4 text-bold-400 px-4">Quotations <i className="fa fa-building float-right"></i></h4>
                              </div>
                              <div className="card-footer p-1">
                              </div>
                          </div>
                        </a>
                      </div>
                    </div>                
            				</div>
                      
                </div>
          </div>  
      </div>
      
    </div>
    );
  }
}


export default List;